import styles from './ScriptModule.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';

export interface ScriptModuleProps {
	script?: string;
	heading?: string;
	height?: string;
}

export const UI_ScriptModule = ({ script, heading, height }: ScriptModuleProps) => {
	const wrapperStyle: React.CSSProperties | undefined = height
		? ({ ['--script-iframe-min-height']: height } as unknown as React.CSSProperties)
		: undefined;

	return (
		<div className={styles.ScriptModule} style={wrapperStyle}>
			{heading && (
				<UI_Heading headingLevel="h2" style="md" className={styles.ScriptModule_heading}>
					{heading}
				</UI_Heading>
			)}
			{script && <div className={styles.ScriptModule_asset} dangerouslySetInnerHTML={{ __html: script }} />}
		</div>
	);
};
